// import { IsProdMode } from "../../utils/AppSetting";

// Web API url
//export const APIURL = (IsProdMode) ? "http://testingimsapi.echemportal.net/api/" : "https://localhost:44321/api/";

// export const APIURL = (IsProdMode) ? process.env.REACT_APP_PreProdApiURL : process.env.REACT_APP_DevApiURL;
// export const APIURL = "https://makoto.nishainfotech.com:100/api/";
export const APIURL = "https://miracalpump.com:100/api/";
// export const APIURL = "https://api.sgtech-test.infixsofttech.com/api/";
// export const APIURL = "https://sgtech-api-test.flyingcapetech.com/api/";


// Mascot API 
// Authentication services
export const GetMasterCompanyList = "Auth/GetMasterCompanyList"
export const SelectedDatabase = "Auth/SelectedDatabase"
export const Login = "Auth/Login"
export const GetAllRoles = "Auth/GetAllRoles"
export const GetModulesWithPermissions = "Auth/GetModulesWithPermissions?id={0}"
export const GetSidebarModules = "Auth/GetSidebarModules?id={0}"
export const SavePermissions = "Auth/SavePermissions"

// Daily Reports Services 
export const ProcItemStockRegister = "DailyReports/ProcItemStockRegister"
export const ProcItemStockRegister_TrackingDetails = "DailyReports/ProcItemStockRegister_TrackingDetails"
export const ProcSelectAllRecord2GridviewSP = "DailyReports/ProcSelectAllRecord2GridviewSP"
export const USP_Master_ItemSelectForItemStockAdjustment = "DailyReports/USP_Master_ItemSelectForItemStockAdjustment?id={0}"
export const GetAdjustmentSelectById = "DailyReports/GetAdjustmentSelectById?id={0}"
export const USP_Master_ItemStockAdjustmentInsert = "DailyReports/USP_Master_ItemStockAdjustmentInsert"
export const USP_Master_ItemStockAdjustmentInsert_new = "DailyReports/USP_Master_ItemStockAdjustmentInsert_new"
export const UpdateStatusForStockAdjustment = "DailyReports/UpdateStatusForStockAdjustment?id={0}&id2={1}"
export const DownloadAdjustmentReport = "DailyReports/DownloadAdjustmentReport?id={0}"
export const USP_Master_ItemUpdateStockAdjustment = "DailyReports/USP_Master_ItemUpdateStockAdjustment"
export const USP_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate = "DailyReports/USP_Master_ItemSelectForItemStockAdjustmentChangeAsPerDate"
export const ProcItemStockRegister_ForMinimumStockLevel = "DailyReports/ProcItemStockRegister_ForMinimumStockLevel?id={0}"
export const ProcItemStockRegister_GroupWise = "DailyReports/ProcItemStockRegister_GroupWise"
export const ProcItemStockRegisterTracking_ByItemGroup = "DailyReports/ProcItemStockRegisterTracking_ByItemGroup"
export const ProcItemStockRegisterWithTotalAmount_ForAccount = "DailyReports/ProcItemStockRegisterWithTotalAmount_ForAccount"
export const ProcItemStockRegister_GroupWise_Dashboard = "DailyReports/ProcItemStockRegister_GroupWise_Dashboard?id={0}"
export const ProcItemStockRegister_ItemGroupWise = "DailyReports/ProcItemStockRegister_ItemGroupWise"
export const ProcItemStockRegisterTracking_ByItemCategory = "DailyReports/ProcItemStockRegisterTracking_ByItemCategory?id={0}"
export const GetAvailableReports = "DailyReports/GetAvailableReports"
export const USP_Extra_UserFormsInsert = "DailyReports/USP_Extra_UserFormsInsert?formName={0}&accessibleName={1}"
export const USP_Reports_TAXSummary_ALLRecords = "DailyReports/USP_Reports_TAXSummary_ALLRecords"
export const USP_Reports_TAXSummary_ALLRecords_Sales = "DailyReports/USP_Reports_TAXSummary_ALLRecords_Sales"
export const DownloadIssueProcessEmployeeReportDateWise = "DailyReports/DownloadIssueProcessEmployeeReportDateWise"
export const USP_Master_ItemGroupSelect = "DailyReports/USP_Master_ItemGroupSelect?id={0}"
export const GetLedgerReportRecords = "DailyReports/GetLedgerReportRecords"
export const GetAccountHeadSummary = "DailyReports/GetAccountHeadSummary"
export const GetBalanceSheetReport = "DailyReports/GetBalanceSheetReport"
export const GetProfitLossReport = "DailyReports/GetProfitLossReport"

// Account Transaction Services
export const ProcSelectAllRecordsSP = "TransactionAccount/ProcSelectAllRecordsSP"
export const USP_Master_PartyAccountSelect = "TransactionAccount/USP_Master_PartyAccountSelect?id={0}"
export const USP_Master_PaymentModeSelect = "TransactionAccount/USP_Master_PaymentModeSelect?id={0}"
export const USP_Master_BankSelect = "TransactionAccount/USP_Master_BankSelect?id={0}"
export const USP_Transaction_PaymentRecvCount = "TransactionAccount/USP_Transaction_PaymentRecvCount"
export const USP_Master_PartyAccountSelectOutstandingAmt = "TransactionAccount/USP_Master_PartyAccountSelectOutstandingAmt"
export const USP_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = "TransactionAccount/USP_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake"
export const USP_Master_ChequeBookNoSelectbyChequeBookSeries = "TransactionAccount/USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForPaymentMake"
export const USP_Transaction_PaymentMakeInsertAndUpdate = "TransactionAccount/USP_Transaction_PaymentMakeInsertAndUpdate"
export const USP_Transaction_PaymentRecvInsertUpdate = "TransactionAccount/USP_Transaction_PaymentRecvInsertUpdate"
export const USP_Transaction_ExpenseCount = "TransactionAccount/USP_Transaction_ExpenseCount"
export const USP_Master_EmployeeSelect = "TransactionAccount/USP_Master_EmployeeSelect?id={0}"
export const USP_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense = "TransactionAccount/USP_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense"
export const USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry = "TransactionAccount/USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry"
export const USP_Master_GeneralProductSelect = "TransactionAccount/USP_Master_GeneralProductSelect?id={0}"
//export const USP_Master_GeneralProductSelect_WithNewChanges = "TransactionAccount/USP_Master_GeneralProductSelect_WithNewChanges?id={0}"
export const USP_Transaction_ExpenseInsertAndUpdate = "TransactionAccount/USP_Transaction_ExpenseInsertAndUpdate"
export const USP_Transaction_PaymentMakeSelectbyId = "TransactionAccount/USP_Transaction_PaymentMakeSelectbyId?id={0}"
export const USP_Transaction_PaymentRecvSelectbyId = "TransactionAccount/USP_Transaction_PaymentRecvSelectbyId?id={0}"
export const USP_Transaction_ExpenseSelectbyId = "TransactionAccount/USP_Transaction_ExpenseSelectbyId?id={0}"
export const USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw = "TransactionAccount/USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForCashWithdraw"
export const USP_Transaction_CashWithdrawCount = "TransactionAccount/USP_Transaction_CashWithdrawCount?id={0}"
export const USP_Transaction_CashWithdrawInsertAndUpdate = "TransactionAccount/USP_Transaction_CashWithdrawInsertAndUpdate?id={0}"
export const USP_Transaction_CashWithdrawSelectbyId = "TransactionAccount/USP_Transaction_CashWithdrawSelectbyId?id={0}"

// General Purchase
export const USP_Transaction_GeneralPurchaseCount = "TransactionAccount/USP_Transaction_GeneralPurchaseCount?id={0}"
export const USP_Extra_NetworkConfigurationSelect = "TransactionAccount/USP_Extra_NetworkConfigurationSelect"
export const USP_Master_PartyAccountSelectGeneral = "TransactionAccount/USP_Master_PartyAccountSelectGeneral?id={0}"
export const USP_Master_UnitSelect = "TransactionAccount/USP_Master_UnitSelect?id={0}"
export const USP_Master_TaxStructureSelect = "TransactionAccount/USP_Master_TaxStructureSelect?id={0}"
export const USP_Extra_GatePassSelect_ForGeneralPurchase = "TransactionAccount/USP_Extra_GatePassSelect_ForGeneralPurchase"
export const USP_Master_PartyAccountSelectbyID = "TransactionAccount/USP_Master_PartyAccountSelectbyID?id={0}"
export const USP_Master_GeneralProductSelectbyID = "TransactionAccount/USP_Master_GeneralProductSelectbyID?id={0}"
export const USP_Master_TaxStructureSelectbyID = "TransactionAccount/USP_Master_TaxStructureSelectbyID?id={0}"
export const USP_Transaction_GeneralPurchaseInsert = "TransactionAccount/USP_Transaction_GeneralPurchaseInsert"
export const USP_Extra_PrefixSelectPrefix = "TransactionAccount/USP_Extra_PrefixSelectPrefix"
export const UploadFile = "TransactionAccount/UploadFile"
export const USP_Transaction_GeneralPurchaseSelectbyId = "TransactionAccount/USP_Transaction_GeneralPurchaseSelectbyId?id={0}"
export const USP_Master_EmployeeSelect_WithNewChanges = "TransactionAccount/USP_Master_EmployeeSelect_WithNewChanges?id={0}"
export const USP_Master_SelectedExpenseByList = "TransactionAccount/USP_Master_SelectedExpenseByList"
export const USP_Transaction_AddCashOrAdvanceCount = "TransactionAccount/USP_Transaction_AddCashOrAdvanceCount"
export const USP_Transaction_AddCashOrAdvanceAddUpdate = "TransactionAccount/USP_Transaction_AddCashOrAdvanceAddUpdate"
export const USP_Transaction_AddCashOrAdvanceSelectbyId = "TransactionAccount/USP_Transaction_AddCashOrAdvanceSelectbyId?id={0}"

// Bank to bank 
export const USP_Transaction_BankToBankTransferCount = "TransactionAccount/USP_Transaction_BankToBankTransferCount"
export const GetChequeBookNoSelectbyChequeBookSeriesForBankToBank = "TransactionAccount/GetChequeBookNoSelectbyChequeBookSeriesForBankToBank"
export const USP_Transaction_BankToBankTransferSelectbyID = "TransactionAccount/USP_Transaction_BankToBankTransferSelectbyID?id={0}"
export const BankToBankTransferAddUpdate = "TransactionAccount/BankToBankTransferAddUpdate"

// Journal voucher 
export const USP_Transaction_JournalVoucherCOUNT = "TransactionAccount/USP_Transaction_JournalVoucherCOUNT"
export const USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher = "TransactionAccount/USP_Master_ChequeBookNoSelectbyChequeBookSeries_ForJournalVoucher"
export const USP_Transaction_JournalVoucherInsertUpdate = "TransactionAccount/USP_Transaction_JournalVoucherInsertUpdate"
export const USP_Transaction_JournalVoucherSelectbyID = "TransactionAccount/USP_Transaction_JournalVoucherSelectbyID?id={0}"

// credit note
export const USP_Transaction_CreditNoteCount = "TransactionAccount/USP_Transaction_CreditNoteCount"
export const USP_Transaction_CreditNoteInsertUpdate = "TransactionAccount/USP_Transaction_CreditNoteInsertUpdate"
export const USP_Transaction_CreditNoteSelectById = "TransactionAccount/USP_Transaction_CreditNoteSelectById?id={0}"

// credit note
export const USP_Transaction_DebitNoteCount = "TransactionAccount/USP_Transaction_DebitNoteCount"
export const USP_Transaction_DebitNoteInsertUpdate = "TransactionAccount/USP_Transaction_DebitNoteInsertUpdate"
export const USP_Transaction_DebitNoteSelectById = "TransactionAccount/USP_Transaction_DebitNoteSelectById?id={0}"
export const USP_Master_PurchaseInwardSelectbyIDPartyFor_DebitNote = "TransactionAccount/USP_Master_PurchaseInwardSelectbyIDPartyFor_DebitNote"

//Employee Salary
export const GetEmployeeSalaryDropdown = "TransactionAccount/GetEmployeeSalaryDropdown"
export const USP_Master_EmployeeSelectbyID_ForSalry = "TransactionAccount/USP_Master_EmployeeSelectbyID_ForSalry?id={0}"
export const USP_Transaction_EmployeeSalaryStructuredInsertUpdate = "TransactionAccount/USP_Transaction_EmployeeSalaryStructuredInsertUpdate"
export const GetTransactionEmployeeSalaryByID = "TransactionAccount/GetTransactionEmployeeSalaryByID?id={0}"
export const GetTransactionEmployeeSalaryDetailsByID = "TransactionAccount/GetTransactionEmployeeSalaryDetailsByID?id={0}"

//Employee Salary
export const GetSalaryToBankDropdown = "TransactionAccount/GetSalaryToBankDropdown"
export const USP_Master_ChequeBookForCompanyToBankTransfer = "TransactionAccount/USP_Master_ChequeBookForCompanyToBankTransfer"
export const USP_Transaction_CompanyToBankTransferSelectbyID = "TransactionAccount/USP_Transaction_CompanyToBankTransferSelectbyID?id={0}"
export const USP_Transaction_CompanyToBankTransferDetailsSelectbyID = "TransactionAccount/USP_Transaction_CompanyToBankTransferDetailsSelectbyID?id={0}"
export const USP_Transaction_CompanyToBankTransferInsertUpdate = "TransactionAccount/USP_Transaction_CompanyToBankTransferInsertUpdate"

// Master Entry
export const USP_Master_CompanySelectbyID = "MasterEntry/USP_Master_CompanySelectbyID?id={0}"
export const USP_Master_ItemStockTransferNewYear = "MasterEntry/USP_Master_ItemStockTransferNewYear?id={0}"
export const  USP_Master_PartyBalanceTransferNewYear = "MasterEntry/USP_Master_PartyBalanceTransferNewYear"
export const  USP_Master_BankClosingTransferNewYear = "MasterEntry/USP_Master_BankClosingTransferNewYear"
export const  USP_TruncateAllRecords = "MasterEntry/USP_TruncateAllRecords"
export const  USP_Master_CompanyUpdate = "MasterEntry/USP_Master_CompanyUpdate"


// Common Services
export const uploadPDF = "Common/UploadPDF";
export const GetFiles = "Common/GetFiles?id={0}&id2={1}";

// Employee Master 
export const GetAllDropdownForEmployeeMaster = "MasterEntry/GetAllDropdownForEmployeeMaster?id={0}"
export const USP_Master_EmployeeInsertUpdate = "MasterEntry/USP_Master_EmployeeInsertUpdate"
export const USP_Master_EmployeeSelectbyID = "MasterEntry/USP_Master_EmployeeSelectbyID?id={0}"


// Account Master
export const USP_Master_BankInsertUpdate = "AccountMaster/USP_Master_BankInsertUpdate"
export const USP_Master_BankSelectbyid = "AccountMaster/USP_Master_BankSelectbyid?id={0}"
export const USP_Master_ExpenseAccountGroupInsertUpdate = "AccountMaster/USP_Master_ExpenseAccountGroupInsertUpdate"
export const USP_Master_ExpenseAccGroupCount = "AccountMaster/USP_Master_ExpenseAccGroupCount?id={0}"
export const USP_Master_ExpenseAccountGroupSelectbyID = "AccountMaster/USP_Master_ExpenseAccountGroupSelectbyID?id={0}"
//export const USP_Master_AccountHeadCount = "AccountMaster/USP_Master_AccountHeadCount"
export const USP_GetAllUsers = "AccountMaster/USP_GetAllUsers"

export const USP_Master_AccountHeadInsertUpdate = "AccountMaster/USP_Master_AccountHeadInsertUpdate"
export const USP_Master_AccountHeadSelectbyID = "AccountMaster/USP_Master_AccountHeadSelectbyID?id={0}"

export const USP_Master_AccountHeadSelect = "AccountMaster/USP_Master_AccountHeadSelect"
export const USP_Master_ExpenseAccountGroupSelect = "AccountMaster/USP_Master_ExpenseAccountGroupSelect?id={0}"
export const USP_Master_GeneralProductInsertUpdate = "AccountMaster/USP_Master_GeneralProductInsertUpdate"


// Party Account Master
export const GetAllDropdownForPartyMaster = "MasterEntry/GetAllDropdownForPartyMaster?id={0}"
export const USP_Master_PartyAccountInsertUpdate = "MasterEntry/USP_Master_PartyAccountInsertUpdate"
export const USP_Master_PartyAccountSelected = "MasterEntry/USP_Master_PartyAccountSelectbyID?id={0}"


// Tax Structure master page 
export const GetMasterDropdownData = "MasterEntry/GetMasterDropdownData"
export const USP_Master_TaxStructureInsertUpdate = "MasterEntry/USP_Master_TaxStructureInsertUpdate"
//export const USP_Master_TaxStructureSelectbyID = "MasterEntry/USP_Master_TaxStructureSelectbyID?id={0}"


// Designation master page 
export const USP_Master_DesignationInsertUpdate = "MasterEntry/USP_Master_DesignationInsertUpdate"
export const USP_Master_DesignationSelectbyID = "MasterEntry/USP_Master_DesignationSelectbyID?id={0}"

// Department master page 
export const USP_Master_DepartmentInsertUpdate = "MasterEntry/USP_Master_DepartmentInsertUpdate"
export const USP_Master_DepartmentSelectbyID = "MasterEntry/USP_Master_DepartmentSelectbyID?id={0}"


// Employee Group master page 
export const USP_Master_EmployeeGroupInsertUpdate = "MasterEntry/USP_Master_EmployeeGroupInsertUpdate"
export const USP_Master_EmployeeGroupSelectbyID = "MasterEntry/USP_Master_EmployeeGroupSelectbyID?id={0}"

// Unit master page 
export const USP_Master_UnitInsertUpdate = "MasterEntry/USP_Master_UnitInsertUpdate"
export const USP_Master_UnitSelectbyID = "MasterEntry/USP_Master_UnitSelectbyID?id={0}"

// Product size master page 
export const USP_Master_ProductSizeInsertUpdate = "MasterEntry/USP_Master_ProductSizeInsertUpdate"
export const USP_Master_ProductSizeSelectbyID = "MasterEntry/USP_Master_ProductSizeSelectbyID?id={0}"

// Material master page 
export const USP_Master_MaterialInsertUpdate = "MasterEntry/USP_Master_MaterialInsertUpdate"
export const USP_Master_MaterialSelectbyId = "MasterEntry/USP_Master_MaterialSelectbyId?id={0}"

// Material master page 
export const USP_Master_PaymentModeInsertUpdate = "MasterEntry/USP_Master_PaymentModeInsertUpdate"
export const USP_Master_PaymentModeSelectbyId = "MasterEntry/USP_Master_PaymentModeSelectbyId?id={0}"

// Material master page 
export const USP_Master_ProcessInsertUpdate = "MasterEntry/USP_Master_ProcessInsertUpdate"
export const USP_Master_ProcessSelectbyID = "MasterEntry/USP_Master_ProcessSelectbyID?id={0}"

// Plant master page 
export const USP_Master_PlantInsertUpdate = "MasterEntry/USP_Master_PlantInsertUpdate"
export const USP_Master_PlantSelectbyId = "MasterEntry/USP_Master_PlantSelectbyId?id={0}"

// Dropdown 
export const GetAllDropdownForStockMaster = "MasterEntry/GetAllDropdownForStockMaster?id={0}"

// Item category master page 
export const USP_Master_ItemCategoryInsertUpdate = "MasterEntry/USP_Master_ItemCategoryInsertUpdate"
export const USP_Master_ItemCategorySelectbyID = "MasterEntry/USP_Master_ItemCategorySelectbyID?id={0}"

// Item category master page 
export const USP_Master_ItemGroupInsertUpdate = "MasterEntry/USP_Master_ItemGroupInsertUpdate"
export const USP_Master_ItemGroupSelectbyID = "MasterEntry/USP_Master_ItemGroupSelectbyID?id={0}"

// Item master 
export const USP_Master_ItemCategorySelectbyItemType = "MasterEntry/USP_Master_ItemCategorySelectbyItemType?id={0}&id2={1}"
export const USP_Master_ItemSelectForAutobyIdCategory = "MasterEntry/USP_Master_ItemSelectForAutobyIdCategory?id={0}&id2={1}"
export const USP_Master_ItemInsertUpdate = "MasterEntry/USP_Master_ItemInsertUpdate"
export const USP_Master_ItemSelectbyID = "MasterEntry/USP_Master_ItemSelectbyID?id={0}"

// Item master 
export const USP_Master_ItemSelectbyItemType = "MasterEntry/USP_Master_ItemSelectbyItemType?id={0}&id2={1}"
export const USP_Master_ProductReceipeInsertUpdate = "MasterEntry/USP_Master_ProductReceipeInsertUpdate"
export const USP_Master_ProductReceipeSelectbyId = "MasterEntry/USP_Master_ProductReceipeSelectbyId?id={0}"

// Item wise process 
export const USP_Master_ItemSelectbyIDCategory = "MasterEntry/USP_Master_ItemSelectbyIDCategory?id={0}&id2={1}"
export const USP_Master_ProcessItemInsertUpdate = "MasterEntry/USP_Master_ProcessItemInsertUpdate"
export const USP_Master_ProcessItemSelectbyID = "MasterEntry/USP_Master_ProcessItemSelectbyID?id={0}"
export const USP_Master_ProcessItemListSelectbyID = "MasterEntry/USP_Master_ProcessItemListSelectbyID?id={0}"

// Plant wise
export const USP_Master_ItemSelectForUpdatePlantWise = "MasterEntry/USP_Master_ItemSelectForUpdatePlantWise?id={0}&id2={1}&id3={2}"
export const USP_Master_PlantItemDetailsInsert = "MasterEntry/USP_Master_PlantItemDetailsInsert"
export const USP_Master_PlantWiseItemSelect = "MasterEntry/USP_Master_PlantWiseItemSelect?id={0}&id2={1}"

// Opening Stock
export const USP_Master_ItemSelectForItemStock = "MasterEntry/USP_Master_ItemSelectForItemStock?id={0}&id2={1}"
export const USP_Master_ItemStockAdminApproved = "MasterEntry/USP_Master_ItemStockAdminApproved"
export const USP_Master_ItemUpdateStock = "MasterEntry/USP_Master_ItemUpdateStock"

// Country Master 
export const USP_Master_CountryInsertUpdate = "AccountMaster/USP_Master_CountryInsertUpdate"
export const USP_Master_CountrySelectbyid = "AccountMaster/USP_Master_CountrySelectbyid?id={0}"

// Dropdown Account master
export const GetAllDropdownForAccountMaster = "AccountMaster/GetAllDropdownForAccountMaster?id={0}&id2={1}"

// State Master
export const USP_Master_StateInsertUpdate = "AccountMaster/USP_Master_StateInsertUpdate"
export const USP_Master_StateSelectbyId = "AccountMaster/USP_Master_StateSelectbyId?id={0}"

// City Master
export const USP_Master_CityInsertUpdate = "AccountMaster/USP_Master_CityInsertUpdate"
export const USP_Master_CitySelectbyId = "AccountMaster/USP_Master_CitySelectbyId?id={0}"

// Cheque Book Master
export const USP_Master_ChequeBookInsertUpdate = "AccountMaster/USP_Master_ChequeBookInsertUpdate"
export const USP_Master_ChequeBookSelectbyID = "AccountMaster/USP_Master_ChequeBookSelectbyID?id={0}"
export const USP_Master_ChequeBookListSelectbyID = "AccountMaster/USP_Master_ChequeBookListSelectbyID?id={0}"


// Procces Item Rate Wise
export const USP_Master_ItemSelectForProcessRateRev = "MasterEntry/USP_Master_ItemSelectForProcessRateRev?id={0}&id2={1}&id3={2}"
export const USP_Master_ItemRateProcesswiseInsert = "MasterEntry/USP_Master_ItemRateProcesswiseInsert"
export const USP_Master_ItemRateProcesswiseDelete = "MasterEntry/USP_Master_ItemRateProcesswiseDelete?id={0}&id2={1}&id3={2}"

// Item Rate Vendor Wise
export const USP_Master_ItemSelectForRateRivision = "MasterEntry/USP_Master_ItemSelectForRateRivision?id={0}&id2={1}&id3={2}"
export const USP_Master_ItemRateVendorwiseInsert = "MasterEntry/USP_Master_ItemRateVendorwiseInsert"
export const USP_Master_ItemRateVendorwiseSelect2 = "MasterEntry/USP_Master_ItemRateVendorwiseSelect2?id={0}"
export const USP_Master_ItemRateVendorwiseUpdate = "MasterEntry/USP_Master_ItemRateVendorwiseUpdate"
export const USP_Master_ItemRateVendorwiseDelete2 = "MasterEntry/USP_Master_ItemRateVendorwiseDelete2?id={0}"
export const Delete_Master_ItemsRecord = "MasterEntry/Delete_Master_ItemsRecord?id={0}"
export const Delete_Master_ItemsExistingItemRecord = "MasterEntry/Delete_Master_ItemsExistingItemRecord?id={0}"
export const Usp_Master_PartyAccountSelectForVendors = "MasterEntry/Usp_Master_PartyAccountSelectForVendors?id={0}&id2={1}"

// Employee Plant Wise
export const USP_Master_EmployeeSelect_ForPlant = "MasterEntry/USP_Master_EmployeeSelect_ForPlant?id={0}&id2={1}&id3={2}"
export const USP_Master_EmployeePlantWiseInsert = "MasterEntry/USP_Master_EmployeePlantWiseInsert"

// Employee Process Wise
export const USP_Master_EmployeeSelect_ForProcess = "MasterEntry/USP_Master_EmployeeSelect_ForProcess?id={0}&id2={1}&id3={2}"
export const USP_Master_EmployeeProcessWiseInsert = "MasterEntry/USP_Master_EmployeeProcessWiseInsert"

// Purchase Order
export const usp_Transaction_PurchaseOrderCount = "TransactionStock/usp_Transaction_PurchaseOrderCount?id={0}&id2={1}"
export const GetAllDropdownAndCountsForTransactionStock = "TransactionStock/GetAllDropdownAndCountsForTransactionStock?id={0}&id2={1}"
export const GetMaster_TaxStructure = "TransactionStock/GetMaster_TaxStructure"
export const USP_Master_ItemSelectbyItemType_Vendorwise = "TransactionStock/USP_Master_ItemSelectbyItemType_Vendorwise?id={0}&id2={1}&id3={2}"
export const USP_Master_ItemSelectbyID_VendorwiseRate = "TransactionStock/USP_Master_ItemSelectbyID_VendorwiseRate?id={0}&id2={1}"
export const USP_Transaction_PurchaseOrderInsertUpdate = "TransactionStock/USP_Transaction_PurchaseOrderInsertUpdate"
export const USP_Transaction_PurchaseOrderSelectbyId = "TransactionStock/USP_Transaction_PurchaseOrderSelectbyId?id={0}"
export const usp_Transaction_PurchaseInquirySelectNotinPurchaseOrder2 = "TransactionStock/usp_Transaction_PurchaseInquirySelectNotinPurchaseOrder2?id={0}&id2={1}&id3={2}"
export const USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems2 = "TransactionStock/USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems2?id={0}&id2={1}&id3={2}&id4={3}"
export const USP_Master_ItemRateVendorwiseSelect3 = "TransactionStock/USP_Master_ItemRateVendorwiseSelect3?id={0}"
export const USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems = "TransactionStock/USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems?id={0}&id2={1}&id3={2}&id4={3}"
export const DownloadPurchaseInvoice = "TransactionStock/DownloadPurchaseInvoice?id={0}&id2={1}"
export const GeneratePendingPurchaseOrderInvoice = "TransactionStock/GeneratePendingPurchaseOrderInvoice?id={0}&id2={1}"
export const SendPurchaseInvoiceMail = "TransactionStock/SendPurchaseInvoiceMail?id={0}&id2={1}&id3={2}&id4={3}"
export const ShareOnWhatsApp = "TransactionStock/ShareOnWhatsApp?id={0}&id2={1}"
 
export const DownloadJobWorkInwardInvoice = "TransactionStock/DownloadJobWorkInwardInvoice?id={0}"
export const usp_Transaction_JobworkInwardDelete = "TransactionStock/usp_Transaction_JobworkInwardDelete?id={0}"

// Material Purchase
export const USP_Extra_GatePassSelect_ForPurchase = "TransactionStock/USP_Extra_GatePassSelect_ForPurchase?id={0}&id2={1}&id3={2}"
export const USP_Transaction_PurchaseInwardInsertUpdate = "TransactionStock/USP_Transaction_PurchaseInwardInsertUpdate"
export const USP_Transaction_PurchaseInwardSelectbyId = "TransactionStock/USP_Transaction_PurchaseInwardSelectbyId?id={0}"
export const USP_Transaction_PurchaseOrderSelectbyIDVendor = "TransactionStock/USP_Transaction_PurchaseOrderSelectbyIDVendor?id={0}&id2={1}&id3={2}&id4={3}"
export const USP_Transaction_PurchaseOrderSelectbyID_PendingQty = "TransactionStock/USP_Transaction_PurchaseOrderSelectbyID_PendingQty>0?id={0}&id2={1}&id3={2}"
export const USP_Master_PartyAccountSelectbyID_withGatePass = "TransactionStock/USP_Master_PartyAccountSelectbyID_withGatePass?id={0}&id2={1}"
export const GenerateMaterialPurchaseReport = "TransactionStock/GenerateMaterialPurchaseReport?id={0}"

// Marerial Planning 
export const USP_Master_PartyAccountSelectCustomerForPlanning = "TransactionStock/USP_Master_PartyAccountSelectCustomerForPlanning?id={0}&id2={1}&id3={2}"
export const USP_Master_PartyAccountSelectCustomerForCalculatePlanning = "TransactionStock/USP_Master_PartyAccountSelectCustomerForCalculatePlanning?id={0}"
export const usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning = "TransactionStock/usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning?id={0}&id2={1}&id3={2}&id4={3}"
export const USP_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning = "TransactionStock/USP_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning?id={0}&id2={1}&id3={2}"
export const USP_Transaction_WorkOrderProductsSelect = "TransactionStock/USP_Transaction_WorkOrderProductsSelect?id={0}"
export const USP_Transaction_WorkOrderRecvProductsSelectbyId = "TransactionStock/USP_Transaction_WorkOrderRecvProductsSelectbyId?id={0}"
export const USP_Master_ProductReceipeSelect_ForWOItem = "TransactionStock/USP_Master_ProductReceipeSelect_ForWOItem?id={0}&id2={1}"
export const USP_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem = "TransactionStock/USP_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem?id={0}&id2={1}&id3={2}"
export const USP_Transaction_MaterialPlanningInsertUpdate = "TransactionStock/USP_Transaction_MaterialPlanningInsertUpdate"
export const usp_Transaction_MaterialPlanningSelectbyId2 = "TransactionStock/usp_Transaction_MaterialPlanningSelectbyId2?id={0}&id2={1}"
export const AddWoBomData = "TransactionStock/AddWoBomData?id={0}&id2={1}&id3={2}"


// Material Job Work 
export const usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2 = "TransactionStock/usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2?id={0}&id2={1}&id3={2}&id4={3}"
export const usp_Transaction_MaterialPlanningSelectbyId = "TransactionStock/usp_Transaction_MaterialPlanningSelectbyId?id={0}&id2={1}"
export const usp_Transaction_MaterialPlanning_MultipleInsertUpdate = "TransactionStock/usp_Transaction_MaterialPlanning_MultipleInsertUpdate"
export const usp_Transaction_MaterialPlanning_MultipleSelectByID = "TransactionStock/usp_Transaction_MaterialPlanning_MultipleSelectByID?id={0}"

export const usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry = "TransactionStock/usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry?id={0}&id2={1}&id3={2}"
export const usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry = "TransactionStock/usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry?id={0}"
export const usp_Transaction_PurchaseInquiryInsertUpdate = "TransactionStock/usp_Transaction_PurchaseInquiryInsertUpdate"
export const usp_Transaction_PurchaseInquirySelectbyId = "TransactionStock/usp_Transaction_PurchaseInquirySelectbyId?id={0}"

// Working planning 
export const usp_Transaction_WorkOrderRecvSelectForWorkPlanning = "TransactionStock/usp_Transaction_WorkOrderRecvSelectForWorkPlanning?id={0}&id2={1}&id3={2}"
export const usp_Transaction_MaterialPlanningSelectbyIDWorkOrder = "TransactionStock/usp_Transaction_MaterialPlanningSelectbyIDWorkOrder?id={0}"
export const usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning = "TransactionStock/usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning?id={0}"
export const USP_Transaction_WorkPlanningInsertUpdate = "TransactionStock/USP_Transaction_WorkPlanningInsertUpdate"
export const usp_Transaction_WorkPlanningSelectbyId = "TransactionStock/usp_Transaction_WorkPlanningSelectbyId?id={0}"

// Material Issue
export const usp_Transaction_MaterialProductionSelectNotinMaterialIssue = "TransactionStock/usp_Transaction_MaterialProductionSelectNotinMaterialIssue?id={0}&id2={1}&id3={2}"
export const usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems = "TransactionStock/usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems?id={0}&id2={1}&id3={2}"
export const USP_Transaction_MaterialIssueInsertUpdate = "TransactionStock/USP_Transaction_MaterialIssueInsertUpdate"
export const usp_Transaction_MaterialIssueSelectbyId = "TransactionStock/usp_Transaction_MaterialIssueSelectbyId?id={0}"
export const usp_Transaction_StoreToPlantDataSelectByItemId = "TransactionStock/usp_Transaction_StoreToPlantDataSelectByItemId?id={0}&id2={1}&id3={2}&id4={3}"

// Material Production
export const usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction = "TransactionStock/usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction?id={0}&id2={1}&id3={2}"
export const usp_Transaction_WorkPlanningSelectNotinMaterialProduction = "TransactionStock/usp_Transaction_WorkPlanningSelectNotinMaterialProduction?id={0}&id2={1}&id3={2}"
export const usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction = "TransactionStock/usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction?id={0}&id2={1}&id3={2}&id4={3}&id5={4}"
export const usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction = "TransactionStock/usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction?id={0}&id2={1}&id3={2}&id4={3}&id5={4}"
export const usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction = "TransactionStock/usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction?id={0}"
export const usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction = "TransactionStock/usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction?id={0}"
export const usp_Master_ProductReceipeSelectbyIdforMaterialProduction = "TransactionStock/usp_Master_ProductReceipeSelectbyIdforMaterialProduction?id={0}"
export const usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO = "TransactionStock/usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO?id={0}"
export const usp_Transaction_MaterialProductionInsetUpdate = "TransactionStock/usp_Transaction_MaterialProductionInsetUpdate"
export const usp_Transaction_MaterialProductionSelectbyId = "TransactionStock/usp_Transaction_MaterialProductionSelectbyId?id={0}"
export const usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges = "TransactionStock/usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges?id={0}"

// Issue Process Material
export const usp_Transaction_IssueProcessTransactionCount = "TransactionStock/usp_Transaction_IssueProcessTransactionCount?id={0}"
export const usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2 = "TransactionStock/usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2?id={0}&id2={1}&id3={2}&id4={3}"
export const usp_Transaction_MaterialIssue_JobWorkSelectPendingItem = "TransactionStock/usp_Transaction_MaterialIssue_JobWorkSelectPendingItem?id={0}&id2={1}"
export const usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess = "TransactionStock/usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess?id={0}"
export const usp_Transaction_MaterialProduction_Serial_Select_ForAssembly = "TransactionStock/usp_Transaction_MaterialProduction_Serial_Select_ForAssembly?id={0}"
export const usp_Master_ProcessItemSelectbyIDItem = "TransactionStock/usp_Master_ProcessItemSelectbyIDItem?id={0}"
export const usp_Transaction_MaterialIssue_JobWorkSelectbyID = "TransactionStock/usp_Transaction_MaterialIssue_JobWorkSelectbyID?id={0}&id2={1}"
export const usp_Transaction_MaterialProduction_SerialNoSelectbyID = "TransactionStock/usp_Transaction_MaterialProduction_SerialNoSelectbyID?id={0}"
export const usp_Transaction_MaterialIssue_JobWorkInsertUpdate = "TransactionStock/usp_Transaction_MaterialIssue_JobWorkInsertUpdate"
export const usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise = "TransactionStock/usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise?id={0}&id2={1}"
export const AddAllocatedQtyEmployeeWise = "TransactionStock/AddAllocatedQtyEmployeeWise"
export const GetAllocatedQtyEmployeeWise = "TransactionStock/GetAllocatedQtyEmployeeWise?id={0}&id2={1}"
export const usp_Transaction_MaterialIssue_JobWorkRecordDelete = "TransactionStock/usp_Transaction_MaterialIssue_JobWorkRecordDelete?id={0}"
export const DownloadIssueProcessEmployeeReport = "TransactionStock/DownloadIssueProcessEmployeeReport?id={0}"

// User Management
export const GetExtraAdminLoginList = "User/GetExtraAdminLoginList?id={0}"
export const AddEditAdminLogin = "User/AddEditAdminLogin"
export const DeleteAdminLogin = "User/DeleteAdminLogin?id={0}"

export const GetExtraUserLoginList = "User/GetExtraUserLoginList?id={0}"
export const AddEditUser = "User/AddEditUser"
export const DeleteUser = "User/DeleteUser?id={0}"

export const GetExtraHODList = "User/GetExtraHODList?id={0}"
export const AddEditHOD = "User/AddEditHOD"
export const DeleteHOD = "User/DeleteHOD?id={0}"

// Role
export const GetAllRoleCategory = "User/GetAllRoleCategory"
export const AddEditRole = "User/AddEditRole"
export const RoleDelete = "User/RoleDelete?id={0}"

// -- Old 
// //Authentication services
// export const AdminLogin = "Account/AdminLogin";
// export const AzureLogin = "Account/AzureLogin";

// //Dashboard services
// export const GetAllEntries = "Dashboard/GetAllEntries";
// export const GetAdminDashboardDetail = "Dashboard/GetAdminDashboardDetail"

// //CorporateMemberships services 
// export const GetAllCorporateMemberList = process.env.REACT_APP_GetAllCorporateMemberList;
// export const GetCorporateMembersById = process.env.REACT_APP_GetCorporateMembersById;
// export const DeleteCorporateMembers = process.env.REACT_APP_DeleteCorporateMembers;
// export const AddEditCorporateMembers = process.env.REACT_APP_AddEditCorporateMembers;
// // export const AddEditOrganisationBasicInformation = "MembershipCorporate/AddEditOrganisationBasicInformation";
// export const GetAllDropdownsForCorporateMember = "MembershipCorporate/GetAllDropdownsForCorporateMember";
// export const AddEditCorporateSIISAccountSegment = "MembershipCorporate/AddEditCorporateSIISAccountInformation";
// export const GetCorporateBasicSIISInformation = "MembershipCorporate/GetCorporateBasicSIISInformation?id={0}";
// export const AddEditCorporateEngagementTracking = "CorporateMember/AddEditCorporateEngagementTracking";
// //export const GetCorporateEngagementTrackingList = "CorporateMember/GetCorporateEngagementTrackingList?id={0}";
// export const GetCorporateEngagementTrackingList = "MembershipCorporate/GetEngagementTrackingListById?id={0}";
// //export const GetCorporateEngagementDetailsById = "MembershipCorporate/GetCorporateEngagementDetailsById?id={0}";
// export const GetCorporateEngagementDetailsById = "MembershipCorporate/GetEngagementTrackingById?id={0}";

// export const AddEditCorporateChapter = "MembershipCorporate/AddEditCorporateChapter";
// export const GetCorporateChapter = "MembershipCorporate/GetCorporateChapter?id={0}";
// export const GetEmployeeInfomationForCorporateMemberAdmin = "MembershipCorporate/GetEmployeeInfomationForCorporateMemberAdmin?id={0}&nameSearch={1}";
// export const GetAllCorporateOrganisationRole = "CorporateMember/GetAllCorporateOrganisationRole?id={0}"
// export const GetChapterCommitteeRoles = "CorporateMember/GetChapterCommitteeRoles?id={0}";
// export const AddEditEmployeeInformation = "MembershipCorporate/AddEditEmployeeInformation";
// export const GetEmployeeInformationById = "MembershipCorporate/GetEmployeeInformationById?id={0}";
// export const AddEditCorporateOrganisationRole = "CorporateMember/AddEditCorporateOrganisationRole";
// export const DeleteCorporateOrganisationRole = "CorporateMember/DeleteCorporateOrganisationRole"
// export const GetCorporateOrganisationRoleById = "CorporateMember/GetCorporateOrganisationRoleById?id={0}";
// export const DeleteChapters = "CommitteeWorkGroup/DeleteChapters"
// //New End Points for create corporate members
// export const AddEditSIISCorporateAccountInformation = "MembershipCorporate/AddEditSIISCorporateAccountInformation";
// export const AddEditEngagementTrackingList = "MembershipCorporate/AddEditEngagementTrackingList";
// export const AddEditProspectInformation = "MembershipCorporate/AddEditProspectInformation";
// export const AddEditCorporateProspect = "MembershipCorporate/AddEditCorporateProspect";
// export const AddEditFinanceCardDetails = "MembershipCorporate/AddEditFinanceCardDetails";
// export const AddEditGovernmentPrograme = "MembershipCorporate/AddEditGovernmentPrograme";
// export const AddEditCorporateMembershipSubscription = "MembershipCorporate/AddEditCorporateMembershipSubscription";
// export const AddEditChapterInformation = "MembershipCorporate/AddEditChapterInformation";
// export const AddEditOrganisationBasicInformation = "MembershipCorporate/AddEditOrganisationBasicInformation";
// export const AddEditOrganisationProfile = "MembershipCorporate/AddEditOrganisationProfile";
// export const AddEditOrganisationBussinessDetails = "MembershipCorporate/AddEditOrganisationBussinessDetails";
// export const AddEditSGTechIntrest = "MembershipCorporate/AddEditSGTechIntrest";
// export const AddEditOrganisationKeyRoles = "MembershipCorporate/AddEditOrganisationKeyRoles";
// export const JoinChapterById = "MembershipCorporate/JoinChapterById";
// export const DeleteChapterById = "MembershipCorporate/DeleteChapterById";
// export const AddEditCorporateCommunication = "MembershipCorporate/AddEditCorporateCommunication";
// export const AddEditOrganisationEmployees = "MembershipCorporate/AddEditOrganisationEmployees";
// export const AddEditFinancialDetail = "MembershipCorporate/AddEditFinancialDetail";
// export const AddEditEvenBookingData = "MembershipCorporate/AddEditEvenBookingData";
// export const GetAllCorporateSectionsById = "MembershipCorporate/GetAllCorporateSectionsById?id={0}";
// export const GetSIISCorporateAccountInformationById = "MembershipCorporate/GetSIISCorporateAccountInformationById?id={0}";
// export const GetEngagementTrackingListById = "MembershipCorporate/GetEngagementTrackingListById?id={0}";
// export const GetFinanceCardDetailsById = "MembershipCorporate/GetFinanceCardDetailsById?id={0}";
// export const GetGovernmentProgrameById = "MembershipCorporate/GetGovernmentProgrameById?id={0}";
// export const GetCorporateMembershipSubscriptionById = "MembershipCorporate/GetCorporateMembershipSubscriptionById?id={0}";
// export const GetProspectInformationById = "MembershipCorporate/GetProspectInformationById?id={0}";
// export const GetChapterInformationById = "MembershipCorporate/GetChapterInformationById?id={0}";
// export const GetOrganisationBasicInformationById = "MembershipCorporate/GetOrganisationBasicInformationById?id={0}";
// export const GetOrganisationProfileById = "MembershipCorporate/GetOrganisationProfileById?id={0}";
// export const GetOrganisationBussinessDetailsById = "MembershipCorporate/GetOrganisationBussinessDetailsById?id={0}";
// export const GetSGTechIntrestById = "MembershipCorporate/GetSGTechIntrestById?id={0}";
// export const GetOrganisationKeyRolesById = "MembershipCorporate/GetOrganisationKeyRolesById?id={0}";
// export const GetWorkgroupDataById = "MembershipCorporate/GetWorkgroupDataById?id={0}";
// export const GetCommunicationById = "MembershipCorporate/GetCommunicationById?id={0}";
// export const GetOrganisationEmployeesById = "MembershipCorporate/GetOrganisationEmployeesById?id={0}";
// export const GetFinancialDetailById = "MembershipCorporate/GetFinancialDetailById?id={0}";
// export const GetEvenBookingDataById = "MembershipCorporate/GetEvenBookingDataById?id={0}";

// //Privileges Services
// export const AddEditPrivileges = process.env.REACT_APP_AddEditPrivileges;
// export const GetPrivilegesList = process.env.REACT_APP_GetPrivilegesList;
// export const GetPrivilegesById = process.env.REACT_APP_GetPrivilegesById;
// export const DeletePrivileges = process.env.REACT_APP_DeletePrivileges;

// //Common Services
// export const GetAllAreaOfExpertise = process.env.REACT_APP_GetAllAreaOfExpertise;
// export const GetAllBusinessSectors = process.env.REACT_APP_GetAllBusinessSectors;
// export const GetAllChapters = process.env.REACT_APP_GetAllChapters;
// export const GetAllCountries = process.env.REACT_APP_GetAllCountries;
// export const GetAllStatus = process.env.REACT_APP_GetAllStatus;
// export const uploadPDF = "Common/UploadPDF";
// export const StoreBase64Image = process.env.REACT_APP_StoreBase64Image;
// export const GetImage = "Common/GetImage";
// export const UploadReconciliationExcel = "Finance/UploadReconciliationExcel";

// //CommunitySpotlight Services
// export const AddEditCommunitySpotlight = process.env.REACT_APP_AddEditCommunitySpotlight;
// export const GetCommunitySpotlight = process.env.REACT_APP_GetCommunitySpotlight;

// //LeadershipPositions Services
// export const AddLeadershipPositions = process.env.REACT_APP_AddLeadershipPositions;
// export const GetLeadershipPositionsList = process.env.REACT_APP_GetLeadershipPositionsList;
// export const GetLeadershipPositionsById = process.env.REACT_APP_GetLeadershipPositionsById;
// export const DeleteLeadershipPositions = process.env.REACT_APP_DeleteLeadershipPositions;
// export const UpdateLeadershipPositions = process.env.REACT_APP_UpdateLeadershipPositions;
// export const GetLeadershipChapters = "LeadershipPositions/GetLeadershipChapters";
// export const GetLeadershipCommittee = "LeadershipPositions/GetLeadershipCommittee";

// //SGTechTV Services
// export const GetSGTechTVList = process.env.REACT_APP_GetSGTechTVList;
// export const GetAllSGTechTVCategory = process.env.REACT_APP_GetAllSGTechTVCategory;
// export const GetSGTechTVById = process.env.REACT_APP_GetSGTechTVById;
// //export const AddEditSGTechTv = process.env.REACT_APP_AddEditSGTechTv; 
// export const AddEditSGTechTv = "SGTechTV/AddEditSGTechTv";
// export const DeleteSGTechTV = "SGTechTV/DeleteSGTechTV";
// export const GetStatusForSGtechTv = "SGTechTV/GetStatusForSGtechTv";
// export const SGTechTVFeaturedCheck = "SGTechTV/SGTechTVFeaturedCheck";


// //Resource Services
// export const GetAllResourcesList = process.env.REACT_APP_GetAllResourcesList;
// export const GetResourceById = process.env.REACT_APP_GetResourceById;
// export const DeleteResources = process.env.REACT_APP_DeleteResources;
// export const AddEditResources = process.env.REACT_APP_AddEditResources;
// export const GetAllResourceTypes = process.env.REACT_APP_GetAllResourceTypes;
// export const GetAllResourceTopics = process.env.REACT_APP_GetAllResourceTopics;
// export const AddEditResourceTaggingDetails = process.env.REACT_APP_AddEditResourceTaggingDetails;
// export const GetResourceTaggingDetails = process.env.REACT_APP_GetResourceTaggingDetails;

// //Banner Services
// // export const AddEditBanners = process.env.REACT_APP_AddEditBanners;
// // export const GetBanners = process.env.REACT_APP_GetBanners;
// export const AddEditBanners = "Banners/AddEditBanners";
// export const GetBanners = "Banners/GetBanners?id={0}";
// export const ClearAllBannersByPositionId = "Banners/ClearAllBannersByPositionId?id={0}";



// // Membership Campaign Services
// export const GetMembershipCampaignList = process.env.REACT_APP_GetMembershipCampaignList;
// export const ActiveInActiveCampaign = "MembershipCampaign/ActiveInActiveMembershipCampaignStatusById";
// export const AddEditMembershipCampaign = "MembershipCampaign/AddEditMembershipCampaign";
// export const GetMembershipCampaignById = "MembershipCampaign/GetMembershipCampaignById?id={0}";
// export const DeleteMembershipCampaign = "MembershipCampaign/DeleteMembershipCampaign";

// // Membership Pricing Services
// export const AddMembershipPricing = "MembershipPricing/AddEditMembershipPricing";
// export const GetMembershipPricing = "MembershipPricing/GetMembershipPricing";

// //Pages Management Services
// export const GetPagesMainModulesList = "PagesManagement/GetPagesMainModulesList";
// export const GetPagesDetailsList = "PagesManagement/GetPagesDetailsList";
// export const GetAllDropdownsForViewPages = "PagesManagement/GetAllDropdownsForViewPages";
// export const GetPageDetailByIds = "PagesManagement/GetPageDetailByIds?MainMenuId={0}&SubMenuId={1}&PageNameId={2}";
// export const GetSubModulesListByMainModuleId = "PagesManagement/GetPagesSubModulesListById?id={0}";
// export const SavePageDetails = "PagesManagement/AddEditPageDetail";
// export const UpdatePageDetails = "PagesManagement/UpdatePageDetails";
// export const GetAllDropdownsForPages = "PagesManagement/GetAllDropdownsForPages";
// export const AddEditPartialPage = "PagesManagement/AddEditPartialPage";
// export const GetPartialPageComponentsById = "PagesManagement/GetPartialPageComponentsById?id={0}";
// export const GetSubPagesListForSubModuleById = "PagesManagement/GetSubPagesListForSubModuleById?id={0}";
// export const AddPageNameForSubModule = "PagesManagement/AddPageNameForSubModule";
// export const DeletePageNamesById = "PagesManagement/DeletePageNamesById";
// export const GetPageDetailByPagesDetailsId = "PagesManagement/GetPageDetailByPagesDetailsId?id={0}";
// export const DeleteStandAlonePageById = "PagesManagement/DeleteStandAlonePageById?id={0}";





// //Notification Announcement Services
// export const GetNotifiicationsList = "NotificationAnnouncement/GetNotifiicationsList";
// export const AddEditNotification = "NotificationAnnouncement/AddEditNotification";
// export const GetNotificationsById = "NotificationAnnouncement/GetNotificationsById?id={0}";
// export const DeleteNotification = "NotificationAnnouncement/DeleteNotification";

// //Authority Limit Services 
// export const GetAuthorityLimitList = "AuthorityLimit/GetAuthorityLimitList";
// export const GetAllMembershipType = "AuthorityLimit/GetAllMembershipType";
// export const GetAllMembershipRevenue = "AuthorityLimit/GetAllMembershipRevenue";
// export const GetAllMembershipCategory = "AuthorityLimit/GetAllMembershipCategory";
// export const GetAllMembershipFeeType = "AuthorityLimit/GetAllMembershipFeeType";
// export const AddEditAuthorityLimit = "AuthorityLimit/AddEditAuthorityLimit";
// export const GetAllMembershipTenure = "AuthorityLimit/GetAllMembershipTenure";
// export const GetAuthorityLimitById = "AuthorityLimit/GetAuthorityLimitById?id={0}";
// export const DeleteAuthorityLimit = "AuthorityLimit/DeleteAuthorityLimit";

// // export const GetAllMembershipTenure = "AuthorityLimit/GetAllMembershipTenure";

// //Membership Task List Services
// export const GetAllTasksList = "MembershipTask/GetAllTasksList";
// export const AddEditMembershipTask = "MembershipTask/AddEditMembershipTask";
// export const GetTaskByCompanyId = "MembershipTask/GetTaskByCompanyId?id={0}";
// export const GetAllSources = "MembershipTask/GetAllSources";
// export const GetAllMembershipTypes = "AuthorityLimit/GetAllMembershipType";
// export const GetAllTransactionaTypes = "MembershipTask/GetAllTransactionaTypes";
// // export const GetPriceTabelForTaskListProcess = "MembershipTask/GetPriceTabelForTaskListProcess";
// export const GetAllBillingCategories = "CorporateMember/GetAllCorporateMemberBillingCategory";
// export const GetAllCorporateProspectSource = "CorporateMember/GetAllCorporateProspectSource";
// export const GetAllDropdownsForMembershipTaskList = "MembershipTask/GetAllDropdownsForMembershipTaskList";
// export const GetPriceTabelByCorporateMemberId = "MembershipTask/GetPriceTabelByCorporateMemberId?id={0}";
// export const GetCalculatedFinalPrice = "MembershipTask/GetCalculatedFinalPrice";
// export const AddEditMembershipTaskAndSendPaymentLink = "MembershipTask/AddEditMembershipTaskAndSendPaymentLink";
// export const GetExistingDiscountTableByTaskId = "MembershipTask/GetExistingDiscountTableByTaskId?id={0}";
// export const SendInvoiceEmailToCorporateMember = "MembershipTask/SendInvoiceEmailToCorporateMember";
// export const SendQuotationEmailToCorporateMember = "MembershipTask/SendQuotationEmailToCorporateMember";
// export const GetAllPriceTables = "MembershipTask/GetAllPriceTables";
// export const AddEditMembershipTaskAndSendForApproval = "MembershipTask/AddEditMembershipTaskAndSendForApproval";
// export const SendEscalateMailToMember = "MembershipTask/SendEscalateMailToMember";
// export const DeleteTaskListDetailsByTaskId = "MembershipTask/DeleteTaskListDetailsByTaskId?id={0}";

// // Chapter X Committee Workgroup Services

// export const AddEditExcoMember = "CommitteeWorkGroup/AddEditExcoMembers";
// export const GetAllExcoPosition = "CommitteeWorkGroup/GetAllExcoPosition";
// export const GetCommitteeWorkGroupList = "CommitteeWorkGroup/GetAllCommitteeWorkGroupList";
// export const GetAllOrganisationName = "IndividualMember/GetAllOrganisationName";
// // export const GetExcoMemberList = "CommitteeWorkGroup/GetExcoMemberList?id={0}";
// export const GetExcoMemberList = "CommitteeWorkGroup/GetExcoMemberList";
// export const GetExcoMemberById = "CommitteeWorkGroup/GetExcoMemberById?id={0}";
// export const GetAllDropdownForChapterXCommittee = "CommitteeWorkGroup/GetAllDropdownForChapterXCommittee";
// export const AddEditChapterDetails = "CommitteeWorkGroup/AddEditChapterDetails"
// export const DeleteCommitteeWorkgroupMapping = "CommitteeWorkGroup/DeleteCommitteeWorkgroupMapping";
// export const DeleteCommittees = "CommitteeWorkGroup/DeleteCommittees";
// export const SearchExcoMemberByEmail = "CommitteeWorkGroup/SearchExcoMemberByEmail";
// export const DeleteEXCOMembers = "CommitteeWorkGroup/DeleteEXCOMembers";


// //Membership Fee Approval

// export const GetAllPendingApprovalTasks = "MembershipFeeApproval/GetAllPendingApprovalTasks";
// export const GetPriceTablesForMembershipFeeApproval = "MembershipFeeApproval/GetPriceTablesForMembershipFeeApproval?id={0}";
// export const UpdatePriceTablesForMembershipFeeApproval = "MembershipFeeApproval/UpdatePriceTablesForMembershipFeeApproval";

// // Individual Member 
// export const GetAllDropdownsForIndividualMember = "IndividualMember/GetAllDropdownsForIndividualMember";
// export const GetIndividualEngagementTrackingList = "IndividualMember/GetIndividualEngagementTrackingList?id={0}";
// export const AddEditEngagementTracking = "IndividualMember/AddEditEngagementTracking";
// export const GetIndividualEngagementTrackingById = "IndividualMember/GetIndividualEngagementTrackingById?id={0}";
// export const AddEditIndividualBasicInformation = "IndividualMember/AddEditIndividualBasicInformation";
// export const AddEditIndividualSIISInformation = "IndividualMember/AddEditIndividualSIISInformation";
// export const GetIndividualBasicInformation = "IndividualMember/GetIndividualBasicInformation?id={0}";
// export const GetIndividualSIISInformation = "IndividualMember/GetIndividualSIISInformation?id={0}";
// export const AddEditIndividualCommittee = "IndividualMember/AddEditIndividualCommittee";
// export const GetIndividualCommittee = "IndividualMember/GetIndividualCommittee?id={0}";
// export const AddEditIndividualMemberSubscription = "IndividualMember/AddEditIndividualMemberSubscription";
// export const GetIndividualMemberSubscription = "IndividualMember/GetIndividualMemberSubscription?id={0}";
// export const GetIndividualContributionList = "IndividualMember/GetIndividualContributionList?id={0}";
// export const AddEditIndividualContribution = "IndividualMember/AddEditIndividualContribution";
// export const GetIndividualMemberList = "IndividualMember/GetIndividualMemberList";
// export const ActiveInActiveIndividualMember = "IndividualMember/ActiveInActiveIndividualMember";
// export const DeleteIndividualMember = "IndividualMember/DeleteIndividualMember";
// export const DeleteIndividualContribution = "IndividualMember/DeleteIndividualContribution";







// // Membership Corporate Services
// export const GetMembershipCorporateList = "CorporateMember/GetMembershipCorporateList";
// export const ActiveInActiveMembershipCorporate = "CorporateMember/ActiveInActiveMembershipCorporate";
// export const DeleteMembershipCorporate = "CorporateMember/DeleteMembershipCorporate";
// export const GetChapterListByCorporateId = "IndividualMember/GetChapterListForIndividualDashboard?id={0}";
// export const GetGovernmentProgrammeDetailByProjectId = "MembershipCorporate/GetGovernmentProgrammeDetailByProjectId?id={0}";
// export const GetCorporateFinancialInfo = "MembershipCorporate/GetCorporateFinancialInfo?id={0}";
// export const GetCorporateFinanceReceiptInvoice = "MembershipCorporate/GetCorporateFinanceReceiptInvoice?id={0}&id2={1}&id3={2}";
// export const RenewCorporateMember = "WebMembershipCorporate/RenewCorporateMember";
// export const SearchIndividualMemberByEmailForOrgRole = "WebMembershipCorporate/SearchIndividualMemberByEmailForOrgRole";
// export const MarkIndivisualMemberAsNonMember = "MembershipCorporate/MarkIndivisualMemberAsNonMember?id={0}";
// export const GetPurchaseChapterDataById = "MembershipCorporate/GetPurchaseChapterDataById?id={0}";
// export const GetAllAvailableChapterListForUpcomingTenure = "WebMembershipCorporate/GetAllAvailableChapterListForUpcomingTenure?id={0}";


// // export const AddEditCorporateSIISAccountSegment = "MembershipCorporate/AddEditCorporateSIISAccountSegment";
// // export const GetCorporateBasicSIISInformation = "MembershipCorporate/GetCorporateBasicSIISInformation";

// export const GetAllCorporateStatus = "MembershipCorporate/GetAllCorporateStatus";


// // New API end points
// export const AddEditSGTechInterestProfile = "IndividualMember/AddEditSGTechInterestProfile";
// export const AddEditCommunicationProfile = "IndividualMember/AddEditCommunicationProfile";
// export const GetIndividualSGTechInterest = "IndividualMember/GetIndividualSGTechInterest?id={0}";
// export const GetIndividualCommunication = "IndividualMember/GetIndividualCommunication?id={0}";
// export const GetAllIndividualProfileDetail = "IndividualMember/GetAllIndividualProfileDetail?id={0}";
// export const GetEmploymentInformation = "IndividualMember/GetEmploymentInformation?id={0}";
// export const AddEditEmploymentInformation = "IndividualMember/AddEditEmploymentInformation";
// export const GetEmailHistoryForIndividualMemberById = "IndividualMember/GetEmailHistoryForIndividualMemberById?id={0}";
// export const GetBookingListForIndividualMemberById = "IndividualMember/GetBookingListForIndividualMemberById";

// //Partnership Services
// export const GetAllGovernmentPartnersList = "Partnerships/GetAllGovernmentPartnersList";
// export const GetAllGovernmentProject = "Partnerships/GetAllGovernmentProject";
// export const GetAllStrategicMembersList = "Partnerships/GetAllStrategicMembersList";
// export const GetAllProjectReviewList = "Partnerships/GetAllProjectReviewList";
// export const DeleteGovernmentAgency = "Partnerships/DeleteGovernmentAgency";
// export const DeleteGovernmentProject = "Partnerships/DeleteGovernmentProject";
// export const DeleteGovernmentStrategicMember = "Partnerships/DeleteGovernmentStrategicMember";
// export const DeleteGovernmentAgencyOfficer = "Partnerships/DeleteGovernmentAgencyOfficer";
// export const GetAllAgencyDropdown = "Partnerships/GetAllAgencyDropdown";
// export const GetAllMemberDropdown = "Partnerships/GetAllMemberDropdown";
// export const GetAllChapterDropdown = "Partnerships/GetAllChapterDropdown";
// export const GetAllAgencyOfficerList = "Partnerships/GetAllAgencyOfficerList?id={0}";
// export const AddEditAgencyOfficer = "Partnerships/AddEditAgencyOfficer";
// export const GetAgencyOfficerById = "Partnerships/GetAgencyOfficerById?id={0}";
// export const AddEditAgencyPartner = "Partnerships/AddEditAgencyPartner";
// export const GetGovernmentAgencyById = "Partnerships/GetGovernmentAgencyById?id={0}";
// export const GetAllCompanyForStrategicMember = "Partnerships/GetAllCompanyForStrategicMember";
// export const GetCompanyOfficerByCompanyForStrategicMember = "Partnerships/GetCompanyOfficerByCompanyForStrategicMember?id={0}&nameSearch={1}";
// export const AddStrategicMember = "Partnerships/AddStrategicMember";
// export const GetAllStrategicMemberList = "Partnerships/GetAllStrategicMemberList";
// export const GetAllSecretariatList = "Partnerships/GetAllSecretariatList";
// export const GetAllGovernmentAgencyList = "Partnerships/GetAllGovernmentAgencyList";
// export const AddEditProject = "Partnerships/AddEditProject";
// export const GetGovernmentProjectById = "Partnerships/GetGovernmentProjectById?id={0}";
// export const AddAgencyOfficerToAddEditProject = "Partnerships/AddAgencyOfficerToAddEditProject";
// export const GetAgencyOfficerListForAddEditProject = "Partnerships/GetAgencyOfficerListForAddEditProject?id={0}";
// export const GetStrategicMemberListForAddEditProject = "Partnerships/GetStrategicMemberListForAddEditProject?id={0}";
// export const UpdateAgencyOfficerKeyStatusForAddeEditProject = "Partnerships/UpdateAgencyOfficerKeyStatusForAddeEditProject";
// export const DeleteAgencyOfficerFromAddEditProject = "Partnerships/DeleteAgencyOfficerFromAddEditProject";
// export const DeleteStrategicMemberFromAddEditProject = "Partnerships/DeleteStrategicMemberFromAddEditProject";

// // Field Management 
// export const GetAllTagTypeDropdown = "FieldManagement/GetAllTagTypeDropdown";
// export const GetAllTagList = "FieldManagement/GetAllTagList";
// export const DeleteTags = "FieldManagement/DeleteTags";
// export const GetTagDetailById = "FieldManagement/GetTagDetailById?id={0}";
// export const AddEditTag = "FieldManagement/AddEditTag";

// export const GetAllProjectTypeDropdown = "FieldManagement/GetAllProjectTypeDropdown";
// export const GetEmailTemplateList = "FieldManagement/GetEmailTemplateList";
// export const DeleteEmailTemplate = "FieldManagement/DeleteEmailTemplate";
// export const GetEmailTemplateById = "FieldManagement/GetEmailTemplateById?id={0}";
// export const AddEditEmailTemplate = "FieldManagement/AddEditEmailTemplate";

// export const GetDropdownRecordList = "FieldManagement/GetDropdownRecordList";
// export const GetDropdownDatabyId = "FieldManagement/GetDropdownDatabyId?id={0}";
// export const DeleteDropdownData = "FieldManagement/Deletedropdowndata";
// export const AddEditDropdownData = "FieldManagement/AddEditDropdownData";
// export const GetTableDataById = "FieldManagement/GetTableDataById?DropdownId={0}&TableDataId={1}";

// // Admin 
// export const AddEditAdminDetails = "Account/AddEditAdminDetails";
    
// export const GetRolesForAdmin = "Account/GetRolesForAdmin";
// export const GetAdminDetailList = "Account/GetAdminDetailList";
// export const GetAdminDetailById = "Account/GetAdminDetailById?id={0}";
// export const DeleteAdminDetailsById = "Account/DeleteAdminDetailsById?id={0}";
// export const ForgotPassword = "Account/ForgotPassword";
// export const ResetPassword = "Account/ResetPassword";

// //Email Management
// export const GetEmailHistoryList = "EmailManagement/GetEmailHistoryList";
// export const DeleteEmailDetailsById = "EmailManagement/DeleteEmailDetailsById?id={0}";

// export const GetAllRecipientsDropdown = "EmailManagement/GetAllRecipientsDropdown";
// export const GetEmailById = "EmailManagement/GetEmailById?id={0}";
// export const AddEditEmail = "EmailManagement/AddEditEmail";


// //Prasad
// //Web Membership Corporate
// export const GetALLMembershipEnquiryList = "WebMembershipCorporate/GetALLMembershipEnquiryList";
// export const GetMembershipEnquiryById = "WebMembershipCorporate/GetMembershipEnquiryById?id={0}";


// //Entry Management
// export const AddEditEntryDetails = "EntryManagement/AddEditEntryDetails";
// export const GetAllDropDownForEntryManagement = "EntryManagement/GetAllDropDownForEntryManagement?id={0}";
// export const GetEntryDetailList = "EntryManagement/GetEntryDetailList";
// export const GetEntryDetailsById = "EntryManagement/GetEntryDetailsById?id={0}";
// export const DeleteEntryDetailsByIds = "EntryManagement/DeleteEntryDetailsByIds";
// export const GetLessonTimeSlotDetailsById = "EntryManagement/GetLessonTimeSlotDetailsById?id={0}";
// export const DeleteEntryTimeSlotById = "EntryManagement/DeleteEntryTimeSlotById";
// export const AddEditOtherEntryDetails = "EntryManagement/AddEditOtherEntryDetails";
// export const AddEditFormQuestion = "EntryManagement/AddEditFormQuestion";
// export const GetFormQuestionByEventId = "EntryManagement/GetFormQuestionByEventId?id={0}";
// export const GetOtherEntryDetailsByEventId = "EntryManagement/GetOtherEntryDetailsByEventId?id={0}";
// export const AddEditEntryLessonTimeSlotDetails = "EntryManagement/AddEditEntryLessonTimeSlotDetails";
// export const GetEntryPricingDetail = "EntryManagement/GetEntryPricingDetail";
// export const AddEditEntryPricingDetail = "EntryManagement/AddEditEntryPricingDetail";
// export const DeleteEntryPricingPackage = "EntryManagement/DeleteEntryPricingPackage";
// export const GetLocationAreaByPostalCode = "EntryManagement/GetLocationAreaByPostalCode?id={0}";
// export const GetSGTechAddressesForEntries = "EntryManagement/GetSGTechAddressesForEntries";
// export const UpdateLessonDetailsById = "EntryManagement/UpdateLessonDetailsById";

// export const GetAllDropDownForCampaignTagging = "EntryManagement/GetAllDropDownForCampaignTagging";
// export const GetCampaignTaggingDetailsByEventId = "EntryManagement/GetCampaignTaggingDetailsByEventId?id={0}";
// export const AddEditCampaignTaggingDetails = "EntryManagement/AddEditCampaignTaggingDetails";
// export const AddEditEntryProgrammeDetail = "EntryManagement/AddEditEntryProgrammeDetail";
// export const GetEntryProgrammeDetailById = "EntryManagement/GetEntryProgrammeDetailById?id={0}";

// export const AddEditEventSectionDetails = "EntryManagement/AddEditEventSectionDetails";
// export const GetEventSectionDetails = "EntryManagement/GetEventSectionDetails?id={0}";
// export const AddEditEventFormPriceList = "EntryManagement/AddEditEventFormPriceList";
// export const GetPriceDetailsForFormByEventId = "EntryManagement/GetPriceDetailsForFormByEventId?id={0}";

// export const GetAllMarketingTrackingURList = "EntryManagement/GetAllMarketingTrackingURList";
// export const GetAllMarketingTrackingURLPartnerList = "EntryManagement/GetAllMarketingTrackingURLPartnerList";
// export const GetAllMarketingTrackingURLEventList = "EntryManagement/GetAllMarketingTrackingURLEventList?id={0}";
// export const AddEditMarketingTrackingURL = "EntryManagement/AddEditMarketingTrackingURL";
// export const DeleteMarketingTrackingURL = "EntryManagement/DeleteMarketingTrackingURL?id={0}";
// export const GetMarketingTrackingURLDetailById = "EntryManagement/GetMarketingTrackingURLDetailById?id={0}";
// export const GetEntryTimeSlotDetailForTaggingByEventId = "EntryManagement/GetEntryTimeSlotDetailForTaggingByEventId?id={0}";
// export const DeleteEventQuestionById = "EntryManagement/DeleteEventQuestionById?id={0}";
// export const DeleteEventAnswerById = "EntryManagement/DeleteEventAnswerById?id={0}";
// export const DeleteSpeakerById = "EntryManagement/DeleteSpeakerById?id={0}";
// export const DeleteAdditionalDescriptionById = "EntryManagement/DeleteAdditionalDescriptionById?id={0}";
// export const DeleteProgrammeTimeById = "EntryManagement/DeleteProgrammeTimeById?id={0}";
// export const GetFeedbackQuestionEntryDetailList = "EntryManagement/GetFeedbackQuestionEntryDetailList";
// export const GetAllFeedbackAnswerListByEventId = "EntryManagement/GetAllFeedbackAnswerListByEventId?id={0}";

// // Finance Management
// export const GetFinanceGSTSettingList = "Finance/GetFinanceGSTSettingList";
// export const GetFinanceClassCodeSettingList = "Finance/GetFinanceClassCodeSettingList";
// export const GetFinanceAccountCodeSettingList = "Finance/GetFinanceAccountCodeSettingList";
// export const GetFinanceCreditNoteApprovalList = "Finance/GetFinanceCreditNoteApprovalList";
// export const AddEditFinanceGST = "Finance/AddEditFinanceGST";
// export const AddEditFinanceClassCode = "Finance/AddEditFinanceClassCode";
// export const AddEditFinanceAccountCode = "Finance/AddEditFinanceAccountCode";
// export const AddEditFinanceCreditNoteApproval = "Finance/AddEditFinanceCreditNoteApproval";
// export const GetCreditNoteInfoForCorporateMember = "Finance/GetCreditNoteInfoForCorporateMember?id={0}&id2={1}";
// export const GetCancellationReasonForCreditNote = "Finance/GetCancellationReasonForCreditNote";
// export const AddFinanceCreditNote = "Finance/AddFinanceCreditNote";
// export const DeleteFinanceGlobal = "Finance/DeleteFinanceGlobal";

// //bookings 
// export const GetbookingsList = "Booking/GetbookingsList";
// export const GetBookingCancellationList = "Booking/GetBookingCancellationList";
// export const GetBookingDetailsById = "Booking/GetBookingDetailsById?id={0}";
// export const GetBookingCancellationDetailsById = "Booking/GetBookingCancellationDetailsById?id={0}";
// export const GetBookingDetailsByBookingId = "Booking/GetBookingDetailsByBookingId?attendeeId={0}&bookingId={1}";
// export const GetInvoiceReceiptPdfByBookingId = "IndividualMember/GetInvoiceReceiptPdfByBookingId?id={0}&type={1}"
// export const GetEventPaymentReconcilationList = "Booking/GetEventPaymentReconcilationList";
// export const GetPaymentProofListDetailsByPaymentProofId = "Booking/GetPaymentProofListDetailsByPaymentProofId?id={0}&typeid={1}";
// export const SavePaymentReconcilationDetailsByAdmin = "Booking/SavePaymentReconcilationDetailsByAdmin";
// export const AcceptTotalPaidAmountInReconcilation = "Booking/AcceptTotalPaidAmountInReconcilation?id={0}";
// export const AcceptTotalMembershipPaidAmountInReconciliation = "MembershipPayment/AcceptTotalMembershipPaidAmountInReconciliation";
// export const AcceptTotalExternalInvoicePaidAmountInReconciliation = "Booking/AcceptTotalExternalInvoicePaidAmountInReconciliation?id={0}";
// export const AcceptTotalPurchaseChapterPaidAmountInReconciliation = "MembershipPayment/AcceptTotalPurchaseChapterPaidAmountInReconciliation?id={0}&membershipPaymentId={1}";
// export const DeleteEventPaymentReconcilation = "Booking/DeleteEventPaymentReconcilation?id={0}";
// export const GetOutstandingInvoicesList = "Booking/GetOutstandingInvoicesList";
// export const AddProofInPaymentProofMapping = "Booking/AddProofInPaymentProofMapping";
// export const GetAllDropdownsForIndividualBooking = "Booking/GetAllDropdownsForIndividualBooking?id={0}";
// export const DownloadBookingSheetByEventId = "Booking/DownloadBookingSheetByEventId?id={0}&id2={1}";





// // Adhok Invoice In Finance 
// export const AddEditFinanceAdhokInvoiceDetail = "Finance/AddEditFinanceAdhokInvoiceDetail";
// export const GetAllDropdownsForFinanceAdhokInvoices = "Finance/GetAllDropdownsForFinanceAdhokInvoices";
// export const GetFinanceAdhocInvoiceList = "Finance/GetFinanceAdhocInvoiceList";
// export const GetFinanceAdhokInvoiceDetail = "Finance/GetFinanceAdhokInvoiceDetail?id={0}";
// export const AddEditFinanceExternalServiceDetail = "Finance/AddEditFinanceExternalServiceDetail";
// export const GetFinanceExternalServiceDetailById = "Finance/GetFinanceExternalServiceDetailById?id={0}";
// export const AddDrawdownForExternalServiceItem = "Finance/AddDrawdownForExternalServiceItem";
// export const GetFinanceCreditNoteById = "Finance/GetFinanceCreditNoteById?id={0}";


// // Voucher Management
// export const GetAllVoucherCodeList = "Finance/GetAllVoucherCodeList";
// export const GetAllFinanceCreditNoteList = "Finance/GetAllFinanceCreditNoteList";
// export const GetFinanceCreditNoteStatusList = "Finance/GetFinanceCreditNoteStatusList";
// export const FinanceApproveRejectCreditNoteApproval = "Finance/FinanceApproveRejectCreditNoteApproval";
// export const GetVoucherCodeDetailsById = "Finance/GetVoucherCodeDetailsById?id={0}";
// export const ActiveInActiveVoucherCode = "Finance/ActiveInActiveVoucherCode";
// export const GetAllMemberListForVoucher = "Finance/GetAllMemberListForVoucher";
// export const AddEditVoucherCodeDetails = "Finance/AddEditVoucherCodeDetails";
// export const GetAllChapterListForVoucher = "Finance/GetAllChapterListForVoucher";
// export const FinanceUpdateCreditNote = "Finance/FinanceUpdateCreditNote";
// export const FinanceUpdateStatusForCreditNote = "Finance/FinanceUpdateStatusForCreditNote";
// export const FinanceGetAllPendingEventApprovalList = "Finance/FinanceGetAllPendingEventApprovalList";
// export const financeEventInvoiceApproval = "Finance/financeEventInvoiceApproval";
// export const FinanceGetInvoice = "Finance/FinanceGetInvoice?path={0}";
// export const FinanceGetCreditNoteInvoice = "Finance/FinanceGetCreditNoteInvoice?id={0}";
// export const UpdatePaymentHistoryForMembershipPayment = "MembershipPayment/UpdatePaymentHistoryForMembershipPayment?id={0}";
// export const UpdatePaymentHistoryForAdditionalChapter = "MembershipPayment/UpdatePaymentHistoryForAdditionalChapter?id={0}";
// export const UpdatePaymentHistory = "Booking/UpdatePaymentHistory?referenceNo={0}&eventVisitorId={1}";
// export const GetAllExtractInvoicesList = "Finance/GetAllExtractInvoicesList";
// export const GetGSTRate = "Common/GetGSTRate";
// export const ZipInvoices = "Finance/ZipInvoices";
// export const FinanceAddCreditNotePaymentProofMapping = "Finance/FinanceAddCreditNotePaymentProofMapping";
// export const AddCreditNoteInvoiceRecordsForBatchJob = "BatchJob/AddCreditNoteInvoiceRecordsForBatchJob?id={0}";
// export const AddMembershipCreditNoteApprovalRecordsForBatchJob = "BatchJob/AddMembershipCreditNoteApprovalRecordsForBatchJob?id={0}";
// export const AddEventCreditNoteApprovalRecordsForBatchJob = "BatchJob/AddEventCreditNoteApprovalRecordsForBatchJob?id={0}";
// export const AddContinuosPeriodExtInvCNApprovalXeroRecords = "BatchJob/AddContinuosPeriodExtInvCNApprovalXeroRecords?id={0}";
// export const ApplyVoucherCodeForMembershipPayment = "Finance/ApplyVoucherCodeForMembershipPayment";
// // For Voucher Reports
// export const GetAllVoucherCodeReportList = "Finance/GetAllVoucherCodeReportList";
// export const GenerateVoucherCodeReport = "Finance/GenerateVoucherCodeReport";
// export const DownloadSheetByVoucherCodeReportId = "Finance/DownloadSheetByVoucherCodeReportId?id={0}";

// // For Deferred Income Reports
// export const GetAllDeferredIncomeReportList = "Finance/GetAllDeferredIncomeReportList";
// export const GenerateDeferredIncomeReport = "Finance/GenerateDeferredIncomeReport";
// export const DownloadSheetByDeferredIncomeReportId = "Finance/DownloadSheetByDeferredIncomeReportId?id={0}";

// // For Transaction Reports
// export const GetAllTransactionReportList = "Finance/GetAllTransactionReportList";
// export const GenerateTransactionReport = "Finance/GenerateTransactionReport";
// export const DownloadSheetByTransactionReportId = "Finance/DownloadSheetByTransactionReportId?id={0}";
// export const GetTransactionRecordList = "Finance/GetTransactionRecordList";
// export const DownloadSheetForTransactionRecord = "Finance/DownloadSheetForTransactionRecord";
// export const GetGenAICyberConnectRecordList = "Finance/GetGenAICyberConnectRecordList";
// export const DownloadSheetForGenAICyberConnectRecord = "Finance/DownloadSheetForGenAICyberConnectRecord" 


// export const BuyChapterForCorporateMember = "MembershipPayment/BuyChapterForCorporateMember";
// export const SendReconciliationPaymentLinkForBuyChapter = "MembershipPayment/SendReconciliationPaymentLinkForBuyChapter";

// export const GetAllWeeklyBatchJobRecords = "BatchJob/GetAllWeeklyBatchJobRecords";
// export const GetAllMonthlyBatchJobRecords = "BatchJob/GetAllMonthlyBatchJobRecords";
// export const GenerateWeeklyBatchJob = "BatchJob/GenerateWeeklyBatchJob?id={0}";
// export const GenerateMonthlyBatchJob = "BatchJob/GenerateMonthlyBatchJob?id={0}";
// export const DownloadSheetByBatchJobId = "BatchJob/DownloadSheetByBatchJobId?id={0}";


// export const GetAllChartsOfAccountCodeList = "BatchJob/GetAllChartsOfAccountCodeList";
// export const GetAllDropdownsForBatchJob = "BatchJob/GetAllDropdownsForBatchJob";
// export const AddEditChartsOfAccountCode = "BatchJob/AddEditChartsOfAccountCode";

// // Go Global API
// export const GetGoGlobalContactRequestList = "GoGlobalAccount/GetGoGlobalContactRequestList";
// export const GetGoGlobalMemberDetailsById = "GoGlobalAccount/GetGoGlobalMemberDetailsById?id={0}";
// export const GetGoGlobalAccountApprovalList = "GoGlobalAccount/GetGoGlobalAccountApprovalList";
// //export const GetStatusList = "GoGlobalAccount/GetStatusList";
// export const GetAllDropDownsForGoGlobalMembers = "GoGlobalAccount/GetAllDropDownsForGoGlobalMembers";
// export const ApproveGoGlobalMemberDetails = "GoGlobalAccount/ApproveGoGlobalMemberDetails";
// export const GetAllGoGlobalClickAnalyticsList = "GoGlobal/GetAllGoGlobalClickAnalyticsList";
// export const AddEditGoGlobalDetails = "GoGlobal/AddEditGoGlobalDetails";
// export const GetCorporateDetailForGoGLobal = "GoGlobal/GetCorporateDetailForGoGLobal?id={0}";
// export const GetDropdownDataByName = "GoGlobal/GetDropdownDataByName";


// // Membership Reports
// export const GenerateMembershipReport = "BatchJob/GenerateMembershipReport";
// export const GetAllMembershipReportList = "BatchJob/GetAllMembershipReportList";
// export const DownloadSheetByMembershipReportId = "BatchJob/DownloadSheetByMembershipReportId?id={0}";

// // AR Aging Reports
// export const GetAllARAgingReportList = "BatchJob/GetAllARAgingReportList";
// export const GenerateARAgingReport = "BatchJob/GenerateARAgingReport";
// export const DownloadARAgingSheetByARAgingReportId = "BatchJob/DownloadARAgingSheetByARAgingReportId?id={0}";

// // GST Reports
// export const GetAllGSTReportList = "BatchJob/GetAllGSTReportList";
// export const GenerateGSTReport = "BatchJob/GenerateGSTReport";
// export const DownloadGSTSheetByGSTReportId = "BatchJob/DownloadGSTSheetByGSTReportId?id={0}";

// // Form Report

// export const GetFormQuestionAnswerEntryDetailList = "EntryManagement/GetFormQuestionAnswerEntryDetailList";
// export const GetAllFormQuestionAnswerListByEventId = "EntryManagement/GetAllFormQuestionAnswerListByEventId?id={0}";

// // Membership Reports
// export const GenerateOrganisationRoleReport = "BatchJob/GenerateOrganisationRoleReport";
// export const GetAllOrganisationRoleReportList = "BatchJob/GetAllOrganisationRoleReportList";
// export const DownloadSheetByOrganisationRoleReportId = "BatchJob/DownloadSheetByOrganisationRoleReportId?id={0}";

// export const DownloadSheetForXeroInvoiceExtractionRecords = "Finance/DownloadSheetForXeroInvoiceExtractionRecords";


// //  DT-SME  
// export const AcceptTotalDTSMEPackagePaidAmountInReconciliation = "DTSME/AcceptTotalDTSMEPackagePaidAmountInReconciliation?id={0}&membershipPaymentId={1}";
// export const GetDTSMEMarketPlaceCompanyInformationList = "DTSME/GetDTSMEMarketPlaceCompanyInformationList";
// export const GetDTSMEMarketPlaceCompanyInformationById = "DTSME/GetDTSMEMarketPlaceCompanyInformationById?id={0}";
// export const AddEditDTSMEMarketPlaceCompanyInformation = "DTSME/AddEditDTSMEMarketPlaceCompanyInformation";
// export const GetALLMarketPlaceCompanyInformationList = "DTSME/GetALLMarketPlaceCompanyInformationList";
// export const GetAllDropdownsForDTSME = "DTSME/GetAllDropdownsForDTSME";
// export const DownloadSheetForDTSMEPurchaseReport = "DTSME/GenerateDTSMEPurchaseReport";
// export const GetDTSMEPurchaseRecordList = "DTSME/GetDTSMEPurchaseRecordList";

// // Reconciliation Excel
// export const DownloadReconciliationExcelTemplate = "Finance/DownloadReconciliationExcelTemplate";
// export const GetAllReconciliationUploadedExcelList = "Finance/GetAllReconciliationUploadedExcelList";
// export const DownloadSheetByReconciliationDataFileId = "Finance/DownloadSheetByReconciliationDataFileId?id={0}";
